module.exports = __webpack_public_path__ + "static/phone-call-1b71c0f08d822fff8f32889a21f3b008.svg";